import { Schema } from 'effect';
/** DTO schemas for the /coach invoicing group. See http/payment.ts for conventions. */
export const InvoiceNumberParams = Schema.Struct({
    invoiceNumber: Schema.String
});
export const InvoiceListResponse = Schema.Struct({
    invoices: Schema.mutable(Schema.Array(Schema.Any)),
    total: Schema.Number
});
export const CreateInvoiceBody = Schema.Struct({
    customer: Schema.Any,
    lineItems: Schema.Any,
    dueDays: Schema.optional(Schema.Number)
});
export const PaymentBody = Schema.Struct({
    amount: Schema.Number.pipe(Schema.check(Schema.isGreaterThan(0))),
    note: Schema.optional(Schema.String)
});
export const MessageResponse = Schema.Struct({ message: Schema.String });
//# sourceMappingURL=coach.js.map